import React, { useContext, useState } from 'react';
import { Linking, Platform, StyleSheet, View } from 'react-native';
import { Button, BottomSheet, Icon, ListItem } from '@rneui/themed';
import Constants from 'expo-constants';
import PropTypes from 'prop-types';
import NavigationList from './NavigationList';
import { Authentication } from '../../common';
import { fetchPage } from '../../../common/Api';
import { collectAncillaryOptions } from '../../../common/helpers/Navigation';
import AppContext, { AppActions, AppEvents } from '../../../contexts/App';
import LayoutContext from '../../../contexts/Layout';

const Menu = props => {
    const { layout } = useContext(LayoutContext);
    const { state, dispatch } = useContext(AppContext);
    const [openBottomSheet, setOpenBottomSheet] = useState();
    const [showLogin, setShowLogin] = useState(false);
    const ancillaryOptions = collectAncillaryOptions(Platform.OS.equals('web') ? state.siteWrapper?.web?.contentItems : state.siteWrapper?.app?.contentItems);

    const getAncillaryMenus = () => {
        if (!layout.device.os.equals('web') && (Constants.manifest2.extra?.environment?.equals('DEV') || Constants.manifest2.extra?.environment?.equals('STG'))) {
            return (
                <View key='login' style={Styles.menuContainer}>
                    <Icon
                        color='#a61a2b'
                        containerStyle={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 20
                        }}
                        name='person'
                        type='material'
                        onPress={() => setShowLogin(!showLogin)}
                    />
                </View>
            );
        } else if (layout.device.os.equals('web')) {
            return ancillaryOptions.menus.map(menu => {
                const menuName = menu.name;

                return (
                    <React.Fragment>
                        <View key={menuName} style={Styles.menuContainer}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Button
                                    containerStyle={{
                                        alignItems: 'center'
                                    }}
                                    icon={{
                                        color: Styles.menuBar.iconColor,
                                        name: 'angle-down',
                                        type: 'font-awesome-5',
                                        size: 16
                                    }}
                                    iconRight={true}
                                    iconContainerStyle={{ paddingRight: 2 }}
                                    onPress={() => setOpenBottomSheet(menuName)}
                                    title={menuName}
                                    titleStyle={Styles.menuContainer?.text}
                                    type='clear'
                                />
                            </View>
                        </View>
                        <BottomSheet isVisible={openBottomSheet === menuName} onBackdropPress={() => setOpenBottomSheet(undefined)}>
                            {menu.entries.map((child, index) => {
                                const isExternal = child.isExternal;
                                const linkText = child.text;
                                const url = child.url;

                                const navigate = async () => {
                                    isExternal ? Linking.openURL(url) : await fetchPage(dispatch, url);
                                    setOpenBottomSheet(undefined);
                                    //toggleNavigation();
                                };

                                return (
                                    <ListItem key={index} onPress={navigate} containerStyle={Styles.bottomSheet.container}>
                                        <ListItem.Content>
                                            <ListItem.Title style={Styles.bottomSheet.titleStyle}>{linkText}</ListItem.Title>
                                        </ListItem.Content>
                                    </ListItem>
                                );
                            })}
                            <ListItem key='menu-cancel' containerStyle={Styles.bottomSheet.cancelBtnContainer} onPress={() => setOpenBottomSheet(undefined)}>
                                <ListItem.Content>
                                    <ListItem.Title style={Styles.bottomSheet.cancelBtnTitle}>Cancel</ListItem.Title>
                                </ListItem.Content>
                            </ListItem>
                        </BottomSheet>
                    </React.Fragment>
                );
            });
        }
    };

    const toggleNavigation = forceClose => {
        if (props.isOpen || forceClose) {
            dispatch({
                type: AppActions.HAMBURGER_STATE_CHANGE,
                state: AppEvents.HAMBURGER_STATE_CLOSED
            });
        } else {
            dispatch({
                type: AppActions.HAMBURGER_STATE_CHANGE,
                state: AppEvents.HAMBURGER_STATE_OPEN
            });
        }
    };

    return (
        <>
            <View style={Styles.menuBar.containerStyle}>
                <Button
                    containerStyle={Styles.menuBar.leftComponent}
                    icon={{
                        ...Styles.menuBar.hamburgerIcon,
                        name: props.isOpen ? 'menu-open' : 'menu'
                    }}
                    onPress={() => toggleNavigation()}
                    type='clear'
                />
                {getAncillaryMenus()}
            </View>
            {props.isOpen && <NavigationList ancillaryOptions={ancillaryOptions} />}
            {showLogin && <Authentication {...props} />}
        </>
    );
};

const Styles = StyleSheet.create({
    menuBar: {
        containerStyle: {
            backgroundColor: '#fff',
            borderBottomColor: '#8897a2',
            borderBottomWidth: StyleSheet.hairlineWidth,
            height: 50,
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        hamburgerIcon: {
            color: '#a61a2b',
            size: 30,
            type: 'material-community'
        },
        leftComponent: {
            alignItems: 'center',
            backgroundColor: 'transparent',
            height: 50,
            justifyContent: 'flex-start'
        },
        logo: {
            justifyContent: 'center',
            source: require('../../../../assets/images/logo.png'),
            type: 'image'
        }
    },
    menuContainer: {
        alignContent: 'center',
        backgroundColor: 'transparent',
        flexDirection: 'row',
        height: 50,
        justifyContent: 'end',
        text: {
            color: '#162b4a',
            fontFamily: 'GothamBook',
            fontSize: '12pt',
            marginRight: 10
        }
    },
    bottomSheet: {
        container: {
            backgroundColor: '#fff',
            borderBottomColor: '#153d6e',
            borderBottomWidth: StyleSheet.hairlineWidth
        },
        titleStyle: {
            color: '#162b4a'
        },
        cancelBtnContainer: {
            backgroundColor: '#6b0410'
        },
        cancelBtnTitle: {
            color: '#fff'
        }
    }
});

Menu.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export default Menu;
